import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/opened-menu.svg'
import _imports_1 from './images/closed-menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-3dfd1a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hamburger-menu" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Зоны доставки ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          class: "hamburger-menu__opened-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
        }))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_1,
          class: "hamburger-menu__closed-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu(true)))
        })),
    _createElementVNode("div", {
      class: _normalizeClass(['hamburger-menu__menu ', { 'hamburger-menu__menu--visible': _ctx.isOpen }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.title,
          to: item.routeSettings,
          class: "hamburger-menu__item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMenu()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      (_ctx.hasDeliveryZone)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'c-delivery-zones' },
            class: "hamburger-menu__item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleMenu()))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}